import {$, w} from './constants';
$(function () {
  const mqMobile = window.matchMedia('(max-width: 950px)');
  let scrollOffset = 94;

  function getBlocks($tabs){
    return $tabs.find('.home-template__modules-block');
  }

  function setNext($tabs){
    const $blocks = getBlocks($tabs);
    $blocks.removeClass('next');

    const $active = $blocks.filter('.active').first();
    const idx = $blocks.index($active);

    if (idx >= 0 && idx < $blocks.length - 1) {
        $blocks.eq(idx + 1).addClass('next');
    }
    }

  function resetBioToDescription($block){
    $block.find('.home-template__modules-block-description-bio').hide();
    $block.find('.home-template__modules-block-description-container').show();
  }

  function closeBlock($block, done){
    resetBioToDescription($block);

    if (mqMobile.matches) {
      const $wrap = $block.find('.home-template__modules-block-description-wrapper').first();
      $wrap.stop(true, false).slideUp(380, function(){
        $block.removeClass('active');
        if (typeof done === 'function') done();
      });
    } else {
      $block.removeClass('active');
      if (typeof done === 'function') done();
    }
  }

  function openBlock($tabs, $block){
    const $blocks  = getBlocks($tabs);
    const $current = $blocks.filter('.active').first();
    if ($current.length && $current[0] === $block[0]) return;

    $('html, body').stop(true);

    const doOpen = () => {
      $block.addClass('active');
      resetBioToDescription($block);
      setActiveWidth($tabs);

      if (mqMobile.matches) {
        const $wrap = $block.find('.home-template__modules-block-description-wrapper').first();
        const $scrollTarget = $block;

        $wrap.stop(true, false).slideDown(380, function(){
          $('html, body').animate(
            { scrollTop: $scrollTarget.offset().top - scrollOffset },
            520
          );
        });
      } else {
      }

      setNext($tabs);
    };

    if ($current.length) resetBioToDescription($current);

    if (mqMobile.matches && $current.length) closeBlock($current, doOpen);
    else {
      if ($current.length) closeBlock($current);
      doOpen();
    }
  }
  
  function setActiveWidth($tabs){
    const $blocks = getBlocks($tabs);
    const count = $blocks.length;
    if (mqMobile.matches) {
      $tabs.css('--tab-active', 'auto');
      return;
    }
    const collapsed = parseFloat(getComputedStyle($tabs[0]).getPropertyValue('--tab-collapsed')) || 165;
    const total = $tabs.width();

    const active = Math.max(0, Math.floor(total - (count - 1) * collapsed));
    $tabs.css('--tab-active', active + 'px');
  }

  $('.home-template__modules-tabs').each(function(){
    const $tabs = $(this);
    const $blocks = getBlocks($tabs);

    let $active = $blocks.filter('.active').first();
    $blocks.not($active).removeClass('active');

    
    if (!$active.length) {
      $active = $blocks.first().addClass('active');
    }

    $blocks.each(function(){
  const $b = $(this);
  const $wrap = $b.find('.home-template__modules-block-description-wrapper').first();

  resetBioToDescription($b);

  if (mqMobile.matches) {
    if ($b.hasClass('active')) $wrap.show();
    else $wrap.hide();
  } else {
    $wrap.show();
  }
});
    setActiveWidth($tabs);
    setNext($tabs);
  });

  $(document).on('click', '.home-template__modules-block-number', function(e){
    const $block = $(this).closest('.home-template__modules-block');
    const $tabs  = $block.closest('.home-template__modules-tabs');
    openBlock($tabs, $block);
  });

  $(document).on('click', '.btn--semblanza', function(e){
    e.preventDefault();
    e.stopPropagation();

    const $block = $(this).closest('.home-template__modules-block');
    if (!$block.hasClass('active')) return;

    $block.find('.home-template__modules-block-description-container').hide();
    $block.find('.home-template__modules-block-description-bio').stop(true, true).fadeIn(150);
  });
  $(document).on('click', '.close_bio, .home-template__modules-block-description-bio .btn--close', function(e){
    e.preventDefault();
    e.stopPropagation();

    const $block = $(this).closest('.home-template__modules-block');
    resetBioToDescription($block);
  });

  let resizeTimer = null;
  $(window).on('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      $('.home-template__modules-tabs').each(function(){
        const $tabs = $(this);
        const $blocks = getBlocks($tabs);
        const $active = $blocks.filter('.active').first();

        $blocks.each(function(){
          const $b = $(this);
          const $wrap = $b.find('.home-template__modules-block-description-wrapper').first();
          $wrap.stop(true, true);

          if (mqMobile.matches) {
            if ($b[0] === $active[0]) $wrap.show();
            else $wrap.hide();
          } else {
            $wrap.show();
          }
        });
        setActiveWidth($tabs);
        setNext($tabs);
      });
    }, 120);
  });

});